// extracted by mini-css-extract-plugin
module.exports = {"popup":"Notification_popup__8483i","popup-inner":"Notification_popup-inner__3WIVi"};